// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Funeral directors (redesign) — /funeral-directors and its editor.
   Depends on dashboard-redesign.css for the shell tokens and shared
   .rf-btn / .rf-num / .rf-spacer / .rf-empty, and on new-order.css for
   the form vocabulary (.rf-field / .rf-label / .rf-input-shell). */

.fdr-page {
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* ---------------- toolbar ---------------- */
.fdr-bar {
  background: #fff;
  border-bottom: 1px solid #e2dcd0;
  padding: 12px 28px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
.fdr-search {
  height: 34px;
  min-width: 250px;
  flex-grow: 1;
  max-width: 380px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border: 1px solid #e2dcd0;
  border-radius: 8px;
  background: #fff;
}
.fdr-search input {
  border: none;
  outline: none;
  background: none;
  width: 100%;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.fdr-search-icon {
  width: 11px;
  height: 11px;
  border: 1.6px solid #a29b8d;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
}
.fdr-search-icon::after {
  content: "";
  position: absolute;
  right: -4px;
  bottom: -3px;
  width: 5px;
  height: 1.6px;
  background: #a29b8d;
  transform: rotate(45deg);
}
/* card / table toggle — .rf-segmented carries the shell, this only
   sizes the icons inside it */
.fdr-view button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 11px;
}
.fdr-view svg {
  font-size: 15px;
}

.fdr-count {
  font-size: 12.5px;
  color: #8b8477;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

/* ---------------- grid ---------------- */
.fdr-body {
  flex-grow: 1;
  min-height: 0;
  padding: 18px 28px 28px;
}
.fdr-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 14px;
}

/* ---------------- table view ----------------
   The legacy page's ten columns, kept 1:1 — the density some of the
   shop prefers for 59 directors — with the special-information note
   the old table dropped shown under the business name. */
.fdr-tablewrap {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  overflow: hidden;
}
.fdr-scroll {
  overflow-x: auto;
}
.fdr-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}
.fdr-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #474339;
  color: #f2efe8;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-align: left;
  padding: 10px 12px;
  white-space: nowrap;
  border: none;
}
.fdr-table tbody td {
  padding: 9px 12px;
  border-bottom: 1px solid #f0ece3;
  vertical-align: top;
  line-height: 1.45;
  color: #4a453c;
}
.fdr-table tbody tr:last-child td {
  border-bottom: none;
}
.fdr-table tbody tr:hover td {
  background: #fdfbf6;
}
.fdr-table tbody tr.is-confirming td {
  background: #f7ebe9;
}
.fdr-t-num {
  width: 38px;
  color: #c4bdad;
  font-size: 11.5px;
  font-variant-numeric: tabular-nums;
}
.fdr-t-code {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--rf-brand);
  min-width: 130px;
  max-width: 210px;
  overflow-wrap: anywhere;
}
.fdr-t-code.is-empty {
  color: #c4bdad;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
}
.fdr-t-name {
  min-width: 150px;
  max-width: 230px;
}
.fdr-t-name b {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  overflow-wrap: break-word;
}
/* the note is clamped to one line here; the full text is the title and
   the card view shows it whole */
.fdr-t-note {
  display: block;
  margin-top: 2px;
  font-size: 11px;
  color: #b0872f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Address + C/C, email + phone, and owner + manager each share one
   cell, stacked and labelled. Three wide columns read better than six
   narrow ones that wrapped every value. */
.fdr-t-pair {
  overflow-wrap: anywhere;
}
.fdr-t-pair.is-loc {
  min-width: 270px;
}
/* wide enough for a full address-style email and a two-word name on
   one line, past the 58px label column */
.fdr-t-pair.is-contact {
  min-width: 272px;
}
.fdr-t-pair.is-people {
  min-width: 196px;
}
.fdr-t-line {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 9px;
  align-items: start;
}
.fdr-t-line + .fdr-t-line {
  margin-top: 5px;
}
.fdr-t-lk {
  font-size: 9.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #c4bdad;
  padding-top: 3px;
}
.fdr-t-lv {
  min-width: 0;
}
.fdr-t-pair.is-contact .fdr-t-lv,
.fdr-t-pair.is-people .fdr-t-lv {
  overflow-wrap: break-word;
}
/* a phone number broken across two lines is unreadable */
.fdr-t-lv.is-nowrap {
  white-space: nowrap;
}
.fdr-table a {
  color: var(--rf-brand);
  text-decoration: none;
  border-bottom: 1px solid var(--rf-brand-line);
}
.fdr-table a:hover {
  color: var(--rf-brand-hover);
  border-bottom-color: var(--rf-brand-soft);
}
.fdr-t-empty {
  color: #c4bdad;
}
.fdr-t-acts {
  width: 1%;
  white-space: nowrap;
  text-align: right;
}
.fdr-t-confirm {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.fdr-t-confirm-text {
  font-size: 11.5px;
  font-weight: 600;
  color: #7d332b;
}
.fdr-t-confirm .rf-btn {
  height: 28px;
  font-size: 12px;
  padding: 0 10px;
}

.fdr-card {
  position: relative;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 14px;
  padding: 16px 18px 14px;
  display: flex;
  flex-direction: column;
  transition: box-shadow 160ms, border-color 160ms;
}
.fdr-card:hover {
  border-color: #d8cfb8;
  box-shadow: 0 10px 26px rgba(40, 34, 22, 0.1);
}

.fdr-head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.fdr-head-main {
  min-width: 0;
  flex-grow: 1;
}
/* The code is not a two-letter tag in practice — it routinely holds the
   whole business name in caps plus a qualifier ("… (KEYS)", "… (SET
   UP)"), which is exactly what distinguishes two records for the same
   firm. So it wraps rather than truncating, and it sits in the card
   footer: \`margin-top: auto\` pins it to the bottom, which lines the
   codes up across a row whatever height the cards stretch to. */
.fdr-foot {
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #f0ece3;
}
.fdr-note + .fdr-foot {
  margin-top: 12px;
}
.fdr-code {
  display: inline-block;
  max-width: 100%;
  padding: 2px 8px;
  border-radius: 6px;
  background: var(--rf-brand-tint);
  border: 1px solid var(--rf-brand-edge);
  color: var(--rf-brand);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.09em;
  line-height: 1.5;
  text-transform: uppercase;
  overflow-wrap: anywhere;
}
.fdr-code.is-empty {
  background: #f4f1ea;
  border-color: #e7e3da;
  color: #c4bdad;
  font-weight: 600;
  letter-spacing: 0.06em;
}
.fdr-name {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.32;
  color: #191714;
  overflow-wrap: break-word;
}
.fdr-people {
  margin-top: 3px;
  font-size: 11.5px;
  color: #a29b8d;
  overflow-wrap: anywhere;
}
.fdr-people b {
  font-weight: 600;
  color: #6f6a60;
}
.fdr-acts {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.fdr-mini {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: none;
  background: none;
  color: #bdb6a7;
  font-size: 17px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.fdr-mini:hover {
  background: #f4f1ea;
  color: #191714;
}
.fdr-mini.is-danger:hover {
  background: #f7ebe9;
  color: #a8483e;
}

.fdr-rows {
  margin-top: 13px;
  padding-top: 12px;
  border-top: 1px solid #f0ece3;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.fdr-row {
  display: flex;
  gap: 10px;
  font-size: 12.5px;
  line-height: 1.45;
}
.fdr-row-k {
  flex-shrink: 0;
  width: 78px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #bdb6a7;
  padding-top: 2px;
}
.fdr-row-v {
  min-width: 0;
  color: #4a453c;
  overflow-wrap: anywhere;
}
.fdr-row-v.is-empty {
  color: #c4bdad;
}
.fdr-row-v a {
  color: var(--rf-brand);
  text-decoration: none;
  border-bottom: 1px solid var(--rf-brand-line);
}
.fdr-row-v a:hover {
  color: var(--rf-brand-hover);
  border-bottom-color: var(--rf-brand-soft);
}
.fdr-pin {
  font-size: 11px;
  vertical-align: -1px;
  margin-right: 3px;
  color: var(--rf-brand-lite);
}

/* the special-information note, only when the director has one */
.fdr-note {
  margin-top: 12px;
  padding: 9px 11px;
  border-radius: 9px;
  background: #fbf8f0;
  border: 1px solid #f0e6cf;
  font-size: 12px;
  line-height: 1.5;
  color: var(--rf-brand-deep);
  overflow-wrap: anywhere;
}
.fdr-note-k {
  display: block;
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--rf-brand-lite);
  margin-bottom: 2px;
}

/* inline delete confirmation, over the card it would delete */
.fdr-confirm {
  position: absolute;
  inset: 0;
  border-radius: 14px;
  background: rgba(255, 252, 248, 0.97);
  border: 1px solid #e3b9b4;
  padding: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
  z-index: 2;
}
.fdr-confirm-text {
  font-size: 12.5px;
  color: #7d332b;
  line-height: 1.5;
}
.fdr-confirm-text b {
  font-weight: 700;
}
.fdr-confirm-acts {
  display: flex;
  gap: 8px;
}
.fdr-btn-danger {
  border: none;
  background: #a8483e;
  color: #fff;
  padding: 0 14px;
}
.fdr-btn-danger:hover:not(:disabled) {
  background: #8f3c33;
}
.fdr-btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ================= editor drawer ================= */
.fde-wrap {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  justify-content: flex-end;
}
.fde-scrim {
  position: absolute;
  inset: 0;
  background: rgba(25, 23, 20, 0.2);
}
.fde-panel {
  position: relative;
  width: 520px;
  max-width: 100%;
  background: #fff;
  border-left: 1px solid #ddd7cb;
  box-shadow: -24px 0 60px rgba(40, 34, 22, 0.16);
  display: flex;
  flex-direction: column;
}
.fde-head {
  padding: 16px 22px;
  border-bottom: 1px solid #e2dcd0;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-shrink: 0;
  background: #fdfcfa;
  text-align: left;
  font-weight: 400;
  margin: 0;
}
.fde-head-main {
  min-width: 0;
  flex-grow: 1;
}
.fde-eyebrow {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
}
.fde-title {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 1.14;
  color: #191714;
  margin: 2px 0 0;
  overflow-wrap: anywhere;
}
.fde-close {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #e2dcd0;
  background: #fff;
  color: #6f6a60;
  font-size: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}
.fde-close:hover {
  background: #f6f4ef;
  color: #191714;
}
.fde-body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 18px 22px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.fde-sec {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a29b8d;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0ece3;
}
.fde-fields {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.fde-foot {
  padding: 12px 22px;
  border-top: 1px solid #e2dcd0;
  background: #fdfcfa;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.fde-foot-note {
  font-size: 12px;
  color: #a29b8d;
  flex-grow: 1;
}

/* Google Places suggestions under a location field */
.fde-places {
  position: relative;
}
.fde-suggests {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 20;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 9px;
  box-shadow: 0 12px 30px rgba(40, 34, 22, 0.14);
  overflow: hidden;
  max-height: 210px;
  overflow-y: auto;
}
.fde-suggest {
  padding: 8px 12px;
  font-size: 12.5px;
  color: #4a453c;
  cursor: pointer;
  border-bottom: 1px solid #f4f1ea;
}
.fde-suggest:last-child {
  border-bottom: none;
}
.fde-suggest.is-active,
.fde-suggest:hover {
  background: #fdfbf6;
  color: #191714;
}
.fde-suggest-loading {
  padding: 8px 12px;
  font-size: 12px;
  color: #bdb6a7;
}
.fde-pinned {
  font-size: 11px;
  color: #4d7a52;
  display: flex;
  align-items: center;
  gap: 4px;
}

@media (max-width: 860px) {
  .fdr-bar,
  .fdr-body {
    padding-left: 16px;
    padding-right: 16px;
  }
}

/* ---------- commission rate ---------- */
.fdr-t-pct {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.fde-pct input {
  -moz-appearance: textfield;
}
.fde-pct input::-webkit-outer-spin-button,
.fde-pct input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.fde-pct-unit {
  color: #8b8477;
  font-size: 13px;
  padding-left: 6px;
}
.fde-help {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: #8b8477;
}
.rf-input-shell.is-error + .fde-help {
  color: #a8483e;
}
`, "",{"version":3,"sources":["webpack://./src/funeral-directors.css"],"names":[],"mappings":"AAAA;;;mEAGmE;;AAEnE;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;8BAC8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;;;yDAGyD;AACzD;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;AACA;iCACiC;AACjC;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;0CAE0C;AAC1C;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;yCACyC;AACzC;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;;EAEE,yBAAyB;AAC3B;AACA,yDAAyD;AACzD;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,4BAA4B;EAC5B,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;;;;;gEAKgE;AAChE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,4BAA4B;EAC5B,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":["/* Funeral directors (redesign) — /funeral-directors and its editor.\n   Depends on dashboard-redesign.css for the shell tokens and shared\n   .rf-btn / .rf-num / .rf-spacer / .rf-empty, and on new-order.css for\n   the form vocabulary (.rf-field / .rf-label / .rf-input-shell). */\n\n.fdr-page {\n  flex-grow: 1;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ---------------- toolbar ---------------- */\n.fdr-bar {\n  background: #fff;\n  border-bottom: 1px solid #e2dcd0;\n  padding: 12px 28px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n.fdr-search {\n  height: 34px;\n  min-width: 250px;\n  flex-grow: 1;\n  max-width: 380px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  border: 1px solid #e2dcd0;\n  border-radius: 8px;\n  background: #fff;\n}\n.fdr-search input {\n  border: none;\n  outline: none;\n  background: none;\n  width: 100%;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.fdr-search-icon {\n  width: 11px;\n  height: 11px;\n  border: 1.6px solid #a29b8d;\n  border-radius: 50%;\n  position: relative;\n  flex-shrink: 0;\n}\n.fdr-search-icon::after {\n  content: \"\";\n  position: absolute;\n  right: -4px;\n  bottom: -3px;\n  width: 5px;\n  height: 1.6px;\n  background: #a29b8d;\n  transform: rotate(45deg);\n}\n/* card / table toggle — .rf-segmented carries the shell, this only\n   sizes the icons inside it */\n.fdr-view button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 11px;\n}\n.fdr-view svg {\n  font-size: 15px;\n}\n\n.fdr-count {\n  font-size: 12.5px;\n  color: #8b8477;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n/* ---------------- grid ---------------- */\n.fdr-body {\n  flex-grow: 1;\n  min-height: 0;\n  padding: 18px 28px 28px;\n}\n.fdr-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\n  gap: 14px;\n}\n\n/* ---------------- table view ----------------\n   The legacy page's ten columns, kept 1:1 — the density some of the\n   shop prefers for 59 directors — with the special-information note\n   the old table dropped shown under the business name. */\n.fdr-tablewrap {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.fdr-scroll {\n  overflow-x: auto;\n}\n.fdr-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12.5px;\n}\n.fdr-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #474339;\n  color: #f2efe8;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  text-align: left;\n  padding: 10px 12px;\n  white-space: nowrap;\n  border: none;\n}\n.fdr-table tbody td {\n  padding: 9px 12px;\n  border-bottom: 1px solid #f0ece3;\n  vertical-align: top;\n  line-height: 1.45;\n  color: #4a453c;\n}\n.fdr-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.fdr-table tbody tr:hover td {\n  background: #fdfbf6;\n}\n.fdr-table tbody tr.is-confirming td {\n  background: #f7ebe9;\n}\n.fdr-t-num {\n  width: 38px;\n  color: #c4bdad;\n  font-size: 11.5px;\n  font-variant-numeric: tabular-nums;\n}\n.fdr-t-code {\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n  min-width: 130px;\n  max-width: 210px;\n  overflow-wrap: anywhere;\n}\n.fdr-t-code.is-empty {\n  color: #c4bdad;\n  font-weight: 500;\n  letter-spacing: 0;\n  text-transform: none;\n}\n.fdr-t-name {\n  min-width: 150px;\n  max-width: 230px;\n}\n.fdr-t-name b {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  overflow-wrap: break-word;\n}\n/* the note is clamped to one line here; the full text is the title and\n   the card view shows it whole */\n.fdr-t-note {\n  display: block;\n  margin-top: 2px;\n  font-size: 11px;\n  color: #b0872f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/* Address + C/C, email + phone, and owner + manager each share one\n   cell, stacked and labelled. Three wide columns read better than six\n   narrow ones that wrapped every value. */\n.fdr-t-pair {\n  overflow-wrap: anywhere;\n}\n.fdr-t-pair.is-loc {\n  min-width: 270px;\n}\n/* wide enough for a full address-style email and a two-word name on\n   one line, past the 58px label column */\n.fdr-t-pair.is-contact {\n  min-width: 272px;\n}\n.fdr-t-pair.is-people {\n  min-width: 196px;\n}\n.fdr-t-line {\n  display: grid;\n  grid-template-columns: 58px minmax(0, 1fr);\n  gap: 9px;\n  align-items: start;\n}\n.fdr-t-line + .fdr-t-line {\n  margin-top: 5px;\n}\n.fdr-t-lk {\n  font-size: 9.5px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #c4bdad;\n  padding-top: 3px;\n}\n.fdr-t-lv {\n  min-width: 0;\n}\n.fdr-t-pair.is-contact .fdr-t-lv,\n.fdr-t-pair.is-people .fdr-t-lv {\n  overflow-wrap: break-word;\n}\n/* a phone number broken across two lines is unreadable */\n.fdr-t-lv.is-nowrap {\n  white-space: nowrap;\n}\n.fdr-table a {\n  color: var(--rf-brand);\n  text-decoration: none;\n  border-bottom: 1px solid var(--rf-brand-line);\n}\n.fdr-table a:hover {\n  color: var(--rf-brand-hover);\n  border-bottom-color: var(--rf-brand-soft);\n}\n.fdr-t-empty {\n  color: #c4bdad;\n}\n.fdr-t-acts {\n  width: 1%;\n  white-space: nowrap;\n  text-align: right;\n}\n.fdr-t-confirm {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n.fdr-t-confirm-text {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #7d332b;\n}\n.fdr-t-confirm .rf-btn {\n  height: 28px;\n  font-size: 12px;\n  padding: 0 10px;\n}\n\n.fdr-card {\n  position: relative;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 14px;\n  padding: 16px 18px 14px;\n  display: flex;\n  flex-direction: column;\n  transition: box-shadow 160ms, border-color 160ms;\n}\n.fdr-card:hover {\n  border-color: #d8cfb8;\n  box-shadow: 0 10px 26px rgba(40, 34, 22, 0.1);\n}\n\n.fdr-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n.fdr-head-main {\n  min-width: 0;\n  flex-grow: 1;\n}\n/* The code is not a two-letter tag in practice — it routinely holds the\n   whole business name in caps plus a qualifier (\"… (KEYS)\", \"… (SET\n   UP)\"), which is exactly what distinguishes two records for the same\n   firm. So it wraps rather than truncating, and it sits in the card\n   footer: `margin-top: auto` pins it to the bottom, which lines the\n   codes up across a row whatever height the cards stretch to. */\n.fdr-foot {\n  margin-top: auto;\n  padding-top: 12px;\n  border-top: 1px solid #f0ece3;\n}\n.fdr-note + .fdr-foot {\n  margin-top: 12px;\n}\n.fdr-code {\n  display: inline-block;\n  max-width: 100%;\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: var(--rf-brand-tint);\n  border: 1px solid var(--rf-brand-edge);\n  color: var(--rf-brand);\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.09em;\n  line-height: 1.5;\n  text-transform: uppercase;\n  overflow-wrap: anywhere;\n}\n.fdr-code.is-empty {\n  background: #f4f1ea;\n  border-color: #e7e3da;\n  color: #c4bdad;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n}\n.fdr-name {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.32;\n  color: #191714;\n  overflow-wrap: break-word;\n}\n.fdr-people {\n  margin-top: 3px;\n  font-size: 11.5px;\n  color: #a29b8d;\n  overflow-wrap: anywhere;\n}\n.fdr-people b {\n  font-weight: 600;\n  color: #6f6a60;\n}\n.fdr-acts {\n  display: flex;\n  gap: 2px;\n  flex-shrink: 0;\n}\n.fdr-mini {\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  border: none;\n  background: none;\n  color: #bdb6a7;\n  font-size: 17px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n.fdr-mini:hover {\n  background: #f4f1ea;\n  color: #191714;\n}\n.fdr-mini.is-danger:hover {\n  background: #f7ebe9;\n  color: #a8483e;\n}\n\n.fdr-rows {\n  margin-top: 13px;\n  padding-top: 12px;\n  border-top: 1px solid #f0ece3;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.fdr-row {\n  display: flex;\n  gap: 10px;\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n.fdr-row-k {\n  flex-shrink: 0;\n  width: 78px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #bdb6a7;\n  padding-top: 2px;\n}\n.fdr-row-v {\n  min-width: 0;\n  color: #4a453c;\n  overflow-wrap: anywhere;\n}\n.fdr-row-v.is-empty {\n  color: #c4bdad;\n}\n.fdr-row-v a {\n  color: var(--rf-brand);\n  text-decoration: none;\n  border-bottom: 1px solid var(--rf-brand-line);\n}\n.fdr-row-v a:hover {\n  color: var(--rf-brand-hover);\n  border-bottom-color: var(--rf-brand-soft);\n}\n.fdr-pin {\n  font-size: 11px;\n  vertical-align: -1px;\n  margin-right: 3px;\n  color: var(--rf-brand-lite);\n}\n\n/* the special-information note, only when the director has one */\n.fdr-note {\n  margin-top: 12px;\n  padding: 9px 11px;\n  border-radius: 9px;\n  background: #fbf8f0;\n  border: 1px solid #f0e6cf;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--rf-brand-deep);\n  overflow-wrap: anywhere;\n}\n.fdr-note-k {\n  display: block;\n  font-size: 9.5px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--rf-brand-lite);\n  margin-bottom: 2px;\n}\n\n/* inline delete confirmation, over the card it would delete */\n.fdr-confirm {\n  position: absolute;\n  inset: 0;\n  border-radius: 14px;\n  background: rgba(255, 252, 248, 0.97);\n  border: 1px solid #e3b9b4;\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  text-align: center;\n  z-index: 2;\n}\n.fdr-confirm-text {\n  font-size: 12.5px;\n  color: #7d332b;\n  line-height: 1.5;\n}\n.fdr-confirm-text b {\n  font-weight: 700;\n}\n.fdr-confirm-acts {\n  display: flex;\n  gap: 8px;\n}\n.fdr-btn-danger {\n  border: none;\n  background: #a8483e;\n  color: #fff;\n  padding: 0 14px;\n}\n.fdr-btn-danger:hover:not(:disabled) {\n  background: #8f3c33;\n}\n.fdr-btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ================= editor drawer ================= */\n.fde-wrap {\n  position: fixed;\n  inset: 0;\n  z-index: 70;\n  display: flex;\n  justify-content: flex-end;\n}\n.fde-scrim {\n  position: absolute;\n  inset: 0;\n  background: rgba(25, 23, 20, 0.2);\n}\n.fde-panel {\n  position: relative;\n  width: 520px;\n  max-width: 100%;\n  background: #fff;\n  border-left: 1px solid #ddd7cb;\n  box-shadow: -24px 0 60px rgba(40, 34, 22, 0.16);\n  display: flex;\n  flex-direction: column;\n}\n.fde-head {\n  padding: 16px 22px;\n  border-bottom: 1px solid #e2dcd0;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  flex-shrink: 0;\n  background: #fdfcfa;\n  text-align: left;\n  font-weight: 400;\n  margin: 0;\n}\n.fde-head-main {\n  min-width: 0;\n  flex-grow: 1;\n}\n.fde-eyebrow {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n}\n.fde-title {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 1.14;\n  color: #191714;\n  margin: 2px 0 0;\n  overflow-wrap: anywhere;\n}\n.fde-close {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid #e2dcd0;\n  background: #fff;\n  color: #6f6a60;\n  font-size: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.fde-close:hover {\n  background: #f6f4ef;\n  color: #191714;\n}\n.fde-body {\n  flex-grow: 1;\n  overflow-y: auto;\n  padding: 18px 22px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.fde-sec {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a29b8d;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #f0ece3;\n}\n.fde-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.fde-foot {\n  padding: 12px 22px;\n  border-top: 1px solid #e2dcd0;\n  background: #fdfcfa;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n.fde-foot-note {\n  font-size: 12px;\n  color: #a29b8d;\n  flex-grow: 1;\n}\n\n/* Google Places suggestions under a location field */\n.fde-places {\n  position: relative;\n}\n.fde-suggests {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 20;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 9px;\n  box-shadow: 0 12px 30px rgba(40, 34, 22, 0.14);\n  overflow: hidden;\n  max-height: 210px;\n  overflow-y: auto;\n}\n.fde-suggest {\n  padding: 8px 12px;\n  font-size: 12.5px;\n  color: #4a453c;\n  cursor: pointer;\n  border-bottom: 1px solid #f4f1ea;\n}\n.fde-suggest:last-child {\n  border-bottom: none;\n}\n.fde-suggest.is-active,\n.fde-suggest:hover {\n  background: #fdfbf6;\n  color: #191714;\n}\n.fde-suggest-loading {\n  padding: 8px 12px;\n  font-size: 12px;\n  color: #bdb6a7;\n}\n.fde-pinned {\n  font-size: 11px;\n  color: #4d7a52;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n@media (max-width: 860px) {\n  .fdr-bar,\n  .fdr-body {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n/* ---------- commission rate ---------- */\n.fdr-t-pct {\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n.fde-pct input {\n  -moz-appearance: textfield;\n}\n.fde-pct input::-webkit-outer-spin-button,\n.fde-pct input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.fde-pct-unit {\n  color: #8b8477;\n  font-size: 13px;\n  padding-left: 6px;\n}\n.fde-help {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #8b8477;\n}\n.rf-input-shell.is-error + .fde-help {\n  color: #a8483e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
